import superagent from 'superagent';
import webservice from './webservice';

export default async function GetFichaTecnicaProducto(id, depto, subdep) {
  let response = {};
  const url = `${webservice}/GetFichaTecnicaProducto?&idProducto=${id}&idioma=0`;

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
